const USERS_URL = "/users";
export async function getUsers(axiosPrivate) {
  try {
    const response = await axiosPrivate.get(USERS_URL);
    return response.data;
  } catch (err) {
    console.error(err);
  }
}
